"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificateService = void 0;
const CertificateServiceLive_1 = require("./CertificateServiceLive");
class CertificateService {
    static create() {
        return new CertificateServiceLive_1.CertificateServiceLive();
    }
}
exports.CertificateService = CertificateService;
//# sourceMappingURL=CertificateService.js.map